$(".burger").click(function() {
    $(".header").addClass("_open")
    $("body").addClass("fixed-body")
})

$(".menu-nav__close").click(function() {
    $(".header").removeClass("_open")
    $("body").removeClass("fixed-body")
})

function cartCalc(){
    $('.cartcalc .ccalc-minus').click(function(){
        let a = $(this).closest('.cartcalc').find('input').val();
        if(a>1){
            let b = +a-1;
            $(this).closest('.cartcalc').find('input').val(b);
        }else{
            $(this).closest('.cartcalc').find('input').val(a);
        }
    });
    $('.cartcalc .ccalc-plus').click(function(){
        let a = $(this).closest('.cartcalc').find('input').val();
        let b = +a+1;
        $(this).closest('.cartcalc').find('input').val(b);
    });
}

cartCalc()
